<template>
  <div @click="$emit('open-video', video)">
    <Tile
      :background="`${$getPlaylistBackground(video.objectID)}`"
      :item="video"
      :isFreeTrialUser="false"
      :isResumeSnipeShown="false"
      :isDifficultyShown="false"
      :isInstructorPictureShown="false"
      :progress="0"
      :displayVendor="false"
      :displayAllInstructors="false"
      :learningAreaColor="getLearningAreaColor(parent)"
      :learningArea="getLearningArea(parent)"
    ></Tile>
  </div>
</template>

<script>
import Tile from '@/components/layout/Tile.vue'
import { getLearningAreaColor, getLearningArea } from '@/helpers'

export default {
  name: 'VideoTile',
  components: {
    Tile,
  },
  data: () => {
    return {
      getLearningAreaColor,
      getLearningArea,
    }
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
    backgroundImg: {
      type: String,
      required: true,
    },
    gradient: {
      type: String,
      required: true,
    },
    duration: {
      type: String,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
  },
}
</script>
